import { render, staticRenderFns } from "./app-chat.vue?vue&type=template&id=5f607b71"
import script from "./app-chat.vue?vue&type=script&lang=js"
export * from "./app-chat.vue?vue&type=script&lang=js"
import style0 from "./app-chat.vue?vue&type=style&index=0&id=5f607b71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports